import { motion } from "framer-motion";

export const HeartFilm = () => (
  <section className="relative bg-black overflow-hidden" data-testid="heart-film-section">
    <div className="relative h-[70vh] lg:h-[85vh]">
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className="absolute inset-0 w-full h-full object-cover"
        data-testid="heart-film-video"
      >
        <source src="/heart-3d.mp4" type="video/mp4" />
        <source src="/heart-3d.webm" type="video/webm" />
      </video>
      <div className="absolute inset-0 bg-gradient-to-b from-navy via-transparent to-navy" />
      <div className="absolute inset-0 bg-black/25" />

      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 lg:px-10 flex flex-col justify-end pb-16 lg:pb-24">
        <motion.div
          initial={{ opacity: 0, y: 36 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-gold mb-4">
            Cinematic Anatomy
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold text-ivory leading-tight max-w-2xl">
            Peer inside the human heart.
          </h2>
          <p className="mt-5 text-sm lg:text-base text-ivory/70 max-w-xl leading-relaxed">
            Every investigation we deliver starts here — with the moving, beating
            structure our specialists read frame by frame. Precision imaging, interpreted
            by clinicians who never lose sight of the anatomy.
          </p>
        </motion.div>
      </div>
    </div>
  </section>
);
